import { MAX_ITEMS_IN_PAGE } from '../../actions/commonActions';

const initState = {
  platforms: [], 
  platform: {}, 
  fullyLoadedBands: {},
  unloadedBands: {}, 
  arrPlatformBands: [],
  currentPage: 1, 
  totalPages: 0, 
  numItems: 0, 
  min: 1, 
  max: MAX_ITEMS_IN_PAGE,
  platformFilter: ''
}

const platformReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_PLATFORMS': 
      return {
        ...state, 
        platforms: action.platforms 
      }
    case 'SET_PLATFORM':
      return {
        ...state, 
        platform: action.platform 
      }
    case 'RESET_PLATFORM': 
      return  {
        ...state, 
        platform: {},
        unloadedBands: {}, 
        fullyLoadedBands: {}, 
        arrPlatformBands: []
      }
    case 'SET_PLATFORMS_PAGINATION':
      return {
        ...state, 
        numItems: action.numItems, 
        min: action.min, 
        totalPages: action.totalPages,
        currentPage: typeof(action.currentPage) !== "undefined" ? action.currentPage : state.currentPage, 
        max: action.max 
      }
    case 'RESET_PLATFORMS_PAGINATION':
      return {
        ...state, 
        currentPage: 1, 
        totalPages: 0, 
        numItems: 0, 
        min: 1, 
        max: MAX_ITEMS_IN_PAGE
      }
    case 'SET_PLATFORM_FIELD_CHANGE': 
      return {
        ...state, 
        platform: Object.assign(state.platform, action.value) 
      }
    case 'SET_FL_BAND_COST_FIELD_CHANGE':
      return {
        ...state, 
        fullyLoadedBands: Object.assign(state.fullyLoadedBands, action.value)
      }
    case 'SET_UL_BAND_COST_FIELD_CHANGE':
      return {
        ...state, 
        unloadedBands: Object.assign(state.unloadedBands, action.value)
      }
    case 'SET_PLATFORM_BANDS':
      return {
        ...state, 
        fullyLoadedBands: action.fullyLoadedBands, 
        unloadedBands: action.unloadedBands, 
        arrPlatformBands: action.arrPlatformBands
      }
    case 'PLATFORM_FILTER':
      return {
        ...state,
        platformFilter: action.filter 
      }
    default: 
      return state;
  }
}

export default platformReducer